import React from 'react';

/**
 * Compact bulk toolbar for entity lists (matches Task bulk action row styling).
 *
 * Pass `actions` for page-specific buttons (e.g. Check in / No-show). Optional
 * `onUpdateLabels` / `onDeleteSelected` keep the original labels + delete contract.
 */
export default function EntityListBulkToolbar({
  selectedCount = 0,
  onUpdateLabels,
  onDeleteSelected,
  updating = false,
  deleting = false,
  ariaLabel = 'Bulk actions',
  updateLabel = 'Update labels',
  deleteLabel = 'Delete',
  actions = [],
}) {
  if (!selectedCount) return null;

  const listBusy = updating || deleting || (Array.isArray(actions) && actions.some((a) => a && a.busy));

  return (
    <div className="toolbar toolbar--task-bulk-actions" role="toolbar" aria-label={ariaLabel}>
      <span className="toolbar-label toolbar--task-bulk-actions__count">
        {selectedCount} selected
      </span>
      {(Array.isArray(actions) ? actions : []).map((action) => {
        if (!action) return null;
        const id = action.id || action.label;
        const disabled = Boolean(action.disabled) || listBusy;
        const className = action.className || 'btn btn-md btn-muted toolbar-control';
        return (
          <button
            key={id}
            type="button"
            className={className}
            disabled={disabled}
            onClick={action.onClick}
            title={action.title}
          >
            {action.busy ? (action.busyLabel || 'Working…') : action.label}
          </button>
        );
      })}
      {onUpdateLabels ? (
        <button
          type="button"
          className="btn btn-md btn-muted toolbar-control"
          disabled={updating || deleting || listBusy}
          onClick={onUpdateLabels}
        >
          {updating ? 'Updating…' : `${updateLabel} (${selectedCount})`}
        </button>
      ) : null}
      {onDeleteSelected ? (
        <button
          type="button"
          className="btn btn-danger toolbar-control"
          disabled={updating || deleting || listBusy}
          onClick={onDeleteSelected}
        >
          {deleting ? 'Deleting…' : `${deleteLabel} (${selectedCount})`}
        </button>
      ) : null}
    </div>
  );
}
